export const CREATE_BUSINESS_CLIENT_STARTED = "CREATE_BUSINESS_CLIENT_STARTED"
export const CREATE_BUSINESS_CLIENT_SUCCESS = "CREATE_BUSINESS_CLIENT_SUCCESS"
export const CREATE_BUSINESS_CLIENT_FAILURE = "CREATE_BUSINESS_CLIENT_FAILURE"


export const SEARCH_BUSINESS_CLIENT_STARTED = "SEARCH_BUSINESS_CLIENT_STARTED"
export const SEARCH_BUSINESS_CLIENT_SUCCESS = "SEARCH_BUSINESS_CLIENT_SUCCESS"
export const SEARCH_BUSINESS_CLIENT_FAILURE = "SEARCH_BUSINESS_CLIENT_FAILURE"

export const CLEAR_SEARCH_RESULT = "CLEAR_SEARCH_RESULT"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
